import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Location } from '@angular/common';
@Component({
  selector: 'eap-confirmation-dialog',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss'],
})
export class ConfirmationDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { message: string; confirmButtonText: string; cancelButtonText: string },
    private location: Location
  ) {
    this.dialogRef.disableClose = true;
  }

  onConfirmClick() {
    this.dialogRef.close(true);
  }

  onClose() {
    this.dialogRef.close(false);
    if (this.data.message == 'You are not authorized to access the Case') {
      this.location.back();
    }
  }
}
